import React from 'react';
import { Alert, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useStyles from './styles';
// eslint-disable-next-line import/no-extraneous-dependencies
import DOMPurify from 'dompurify';
export default function InformationBanner(_ref) {
  let type = _ref.type,
    text = _ref.text,
    title = _ref.title,
    btnLink = _ref.btnLink,
    btnTitle = _ref.btnTitle,
    _ref$btnTarget = _ref.btnTarget,
    btnTarget = _ref$btnTarget === void 0 ? '_blank' : _ref$btnTarget,
    handleCross = _ref.handleCross;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: type,
    icon: false,
    size: "small",
    onClose: () => handleCross()
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, title || 'Notification title'), text && text.length && /*#__PURE__*/React.createElement("div", {
    className: classes.bannerContent,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(text)
    }
  }), btnLink && btnTitle && /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: btnLink,
    target: btnTarget,
    variant: "text",
    size: "small",
    'custom-attribute': '336-InformationBanner'
  }, btnTitle))));
}